import { ComplexValue } from 'app/types-shared';
import { ExternalUrlItem, ExternalUrlItemValidation } from './types-store';

export const ACTION = {
  REQUEST_LANGUAGE_OPTIONS: 'EXTERNAL_URL_ADMIN_FORM:REQUEST_LANGUAGE_OPTIONS',
  RECEIVE_LANGUAGE_OPTIONS: 'EXTERNAL_URL_ADMIN_FORM:RECEIVE_LANGUAGE_OPTIONS',
  FAIL_LANGUAGE_OPTIONS: 'EXTERNAL_URL_ADMIN_FORM:FAIL_LANGUAGE_OPTIONS',

  REQUEST_EXTERNAL_URL: 'EXTERNAL_URL_ADMIN_FORM:REQUEST_EXTERNAL_URL',
  RECEIVE_EXTERNAL_URL: 'EXTERNAL_URL_ADMIN_FORM:RECEIVE_EXTERNAL_URL',
  FAIL_EXTERNAL_URL: 'EXTERNAL_URL_ADMIN_FORM:FAIL_EXTERNAL_URL',

  REQUEST_DELETE_EXTERNAL_URL: 'EXTERNAL_URL_ADMIN_FORM:REQUEST_DELETE_EXTERNAL_URL',
  RECEIVE_DELETE_EXTERNAL_URL: 'EXTERNAL_URL_ADMIN_FORM:RECEIVE_DELETE_EXTERNAL_URL',
  FAIL_DELETE_EXTERNAL_URL: 'EXTERNAL_URL_ADMIN_FORM:FAIL_DELETE_EXTERNAL_URL',

  REQUEST_SAVE_EXTERNAL_URL: 'EXTERNAL_URL_ADMIN_FORM:REQUEST_SAVE_EXTERNAL_URL',
  RECEIVE_SAVE_EXTERNAL_URL: 'EXTERNAL_URL_ADMIN_FORM:RECEIVE_SAVE_EXTERNAL_URL',
  FAIL_SAVE_EXTERNAL_URL: 'EXTERNAL_URL_ADMIN_FORM:FAIL_SAVE_EXTERNAL_URL',

  UPDATE_EXCLUDED_FIELDS: 'EXTERNAL_URL_ADMIN_FORM:UPDATE_EXCLUDED_FIELDS',
  UPDATE_ITEM: 'EXTERNAL_URL_ADMIN_FORM:UPDATE_ITEM',

  CHANGE_LANGUAGE: 'EXTERNAL_URL_ADMIN_FORM:CHANGE_LANGUAGE',
  COPY_LANGUAGE_TO_ALL: 'EXTERNAL_URL_ADMIN_FORM:COPY_LANGUAGE_TO_ALL',

  CHANGE_LONG_DESCRIPTION: 'EXTERNAL_URL_ADMIN_FORM: CHANGE_LONG_DESCRIPTION',
  COPY_LONG_DESCRIPTION_TO_ALL: 'EXTERNAL_URL_ADMIN_FORM:COPY_LONG_DESCRIPTION_TO_ALL',

  CLEAR_FORM: 'EXTERNAL_URL_ADMIN_FORM:CLEAR_FORM',

  UPDATE_VALIDATION: 'EXTERNAL_URL_ADMIN_FORM:UPDATE_VALIDATION',
  UPDATE_VALIDATION_BY_KEY: 'EXTERNAL_URL_ADMIN_FORM:UPDATE_VALIDATION_BY_KEY',
  RESET_VALIDATION: 'EXTERNAL_URL_ADMIN_FORM:RESET_VALIDATION'
};

export class RequestLanguageOptions {
  public type: string = ACTION.REQUEST_LANGUAGE_OPTIONS;
}

export class ReceiveLanguageOptions {
  public type: string = ACTION.RECEIVE_LANGUAGE_OPTIONS;
  constructor(public options: ComplexValue<number>[]) { }
}

export class FailLanguageOptions {
  public type: string = ACTION.FAIL_LANGUAGE_OPTIONS;
}

export class RequestExternalUrl {
  public type: string = ACTION.REQUEST_EXTERNAL_URL;
}

export class ReceiveExternalUrl {
  public type: string = ACTION.RECEIVE_EXTERNAL_URL;
  constructor(
    public item: ExternalUrlItem
  ) { }
}

export class FailExternalUrl {
  public type: string = ACTION.FAIL_EXTERNAL_URL;
}

export class RequestDeleteExternalUrl {
  public type: string = ACTION.REQUEST_DELETE_EXTERNAL_URL;
}

export class ReceiveDeleteExternalUrl {
  public type: string = ACTION.RECEIVE_DELETE_EXTERNAL_URL;
}

export class FailDeleteExternalUrl {
  public type: string = ACTION.FAIL_DELETE_EXTERNAL_URL;
}

export class RequestSaveExternalUrl {
  public type: string = ACTION.REQUEST_SAVE_EXTERNAL_URL;
}

export class ReceiveSaveExternalUrl {
  public type: string = ACTION.RECEIVE_SAVE_EXTERNAL_URL;
}

export class FailSaveExternalUrl {
  public type: string = ACTION.FAIL_SAVE_EXTERNAL_URL;
}

export class UpdateExcludedFields {
  public type: string = ACTION.UPDATE_EXCLUDED_FIELDS;
  constructor(public excludedFields: ComplexValue<number>[]) {
  }
}

export class ClearForm {
  public type: string = ACTION.CLEAR_FORM;
}

export class UpdateItem {
  public type: string = ACTION.UPDATE_ITEM;
  constructor(public item: Partial<ExternalUrlItem>) { }
}

export class ChangeLanguage {
  public type: string = ACTION.CHANGE_LANGUAGE;
  constructor(public languageId: number, public description: string) { }
}

export class CopyLanguageToAll {
  public type: string = ACTION.COPY_LANGUAGE_TO_ALL;
  constructor(public languageId: number) { }
}

export class ChangeLongDescription {
  public type: string = ACTION.CHANGE_LONG_DESCRIPTION;
  constructor(public languageId: number, public description: string) { }
}

export class CopyLongDescriptionToAll {
  public type: string = ACTION.COPY_LONG_DESCRIPTION_TO_ALL;
  constructor(public languageId: number) { }
}
export class UpdateValidation {
  public type: string = ACTION.UPDATE_VALIDATION;
  constructor(public validation: ExternalUrlItemValidation) { }
}

export class ResetValidation {
  public type: string = ACTION.RESET_VALIDATION;
  constructor(public key: string) {
  }
}
